<mat-radio-group
  [(ngModel)]="radioSecondSelected"
  (change)="onRadioChange($event)"
  [ngModelOptions]="{ standalone: true }"
  [disabled]="isRadioDisabled"
  color="primary"
  >
  @for (obj of corporateDividendRadio; track obj) {
    <mat-radio-button
      [value]="obj.value"
      >
      <span>
        {{ obj.key }}
      </span>
    </mat-radio-button>
  }
</mat-radio-group>
